import { render, staticRenderFns } from "./SectionRelatedProgram.vue?vue&type=template&id=26abb860&scoped=true&"
import script from "./SectionRelatedProgram.vue?vue&type=script&lang=js&"
export * from "./SectionRelatedProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26abb860",
  null
  
)

export default component.exports